import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { LoadingIcon } from "../../../assets/svg/loadingIcon";
import AgSwipe from "../../../components/AgSwipe";
import Card from "../../../components/Card";
import { TblInboxMessage } from "../../../models";
import ItemCardMessage from "../itemCardMessage";
import { ICardMessageMobileTable } from "./cardMessageMobileTable.props";

const CardMessageMobileTable: React.FC<ICardMessageMobileTable> = ({
  data,
  maxLength,
  page,
  entriesPerPage = 8,
  onHandleNextPage,
  pageCount,
  isClickOnRow = false,
  onClickOnRow,
  textNoDataFound = "No Records Found",
  isReceivedTab,
  isLoading,
  onClickEdit,
  getInquiryDetails,
  setDeletedInboxMessageId,
  updateInfoAction,
  loadMore = () => { },
  isClickExportExcel,
  isClickAddInquiry,
  isClickFilterOnMobile,
  onCloseTrailItem,
  ...props
}: ICardMessageMobileTable) => {

  const [currentOpenIndex, setCurrentOpenIndex] = useState<number | null>(null);
  const [isCloseAllTrailItems, SetIsCloseAllTrailItems] = useState<boolean | null>(null);

  const rightActions = (e: TblInboxMessage) => (
    <>
      <div className="flex h-full">
        <div
          className=" bg-[#0971A2] flex flex-col items-center justify-center w-[80px] h-full text-white font-bold"
          onClick={() => {
            getInquiryDetails(e.inboxMessageId);
            onClickEdit(e.inboxMessageId);
            SetIsCloseAllTrailItems(true);
          }}
        >
          <div>Edit</div>
          <div>
            <EditIcon></EditIcon>
          </div>
        </div>

        <div
          className="bg-[#e12626] flex flex-col items-center justify-center w-[80px] h-full text-white font-bold"
          onClick={() => {
            setDeletedInboxMessageId(e.inboxMessageId!);
            updateInfoAction("Delete", e);
            SetIsCloseAllTrailItems(true);
          }}
        >
          <div>Delete</div>
          <div>
            <DeleteIcon></DeleteIcon>
          </div>
        </div>
      </div>
    </>
  );

  useEffect(() => {
  }, [isCloseAllTrailItems]);

  return (
    <InfiniteScroll
      dataLength={data.length}
      next={loadMore}
      hasMore={data ? data.length < (maxLength as number) : false}
      loader={<div className="flex flex-row px-[20px] py-[5px] justify-center border-t-2">
        <LoadingIcon
          width={60}
          height={60}
        />
      </div>}
      scrollableTarget="scrollableDiv"
      scrollThreshold={0.9}
    >
      <Card
        borderRadius={false}
        className={`divide-y divide-neutral-500-700 ${!(data && data.length) ? "!bg-transparent" : ""
          }`}
      >
        {/* {!isLoading && data && data.length ? ( */}
        <div className="divide-y-2 divide-neutral-500-700">

          {data.map((e) => {
            return (
              <AgSwipe
                data={e}
                elementId={e.inboxMessageId!}
                onClickElement={onClickOnRow}
                setOpenIndex={(e: number | null) => { setCurrentOpenIndex(e) }}
                currentOpenIndex={currentOpenIndex}
                onCloseAllTrailItems={(e: boolean) => { SetIsCloseAllTrailItems(e) }}
                isCloseAllTrailItems={isCloseAllTrailItems}
                isClickAddInquiry={isClickAddInquiry}
                isClickExportExcel={isClickExportExcel}
                isClickFilterOnMobile={isClickFilterOnMobile}
                childElement={
                  <ItemCardMessage
                    data={e}
                    isReceivedTab={isReceivedTab}
                  />}
                TrailItems={rightActions(e)}
                TrailItemsWidth={160}
                onCloseTrailItem={onCloseTrailItem} />
            );
          })}
        </div>

        {
          !isLoading && (!data || !data.length) && (
            <div className="flex flex-row px-[20px] py-[5px] justify-center border-t-[1px] border-solid border-[#EAEAEA]">
              <p className="text-[14px] font-normal text-[#637381]">
                {textNoDataFound ?? "No Records Found"}
              </p>
            </div>
          )

        }
      </Card>
    </InfiniteScroll>

  );
};

const EditIcon = (props: any) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.20615 16.1426L0 20.3663L4.22375 19.1602L1.20615 16.1426Z"
        fill="white"
      ></path>
      <path
        d="M19.9284 3.46349L17.9234 5.46845L14.9365 2.48153L16.9415 0.476562L19.9284 3.46349Z"
        fill="white"
      ></path>
      <path
        d="M2.125 15.2518L14.0721 3.30469L17.059 6.29161L5.11192 18.2387L2.125 15.2518Z"
        fill="white"
      ></path>
    </svg>
  );
};

const DeleteIcon = (props: any) => {
  return (
    <svg
      width={23}
      height={23}
      xmlns="http://www.w3.org/2000/svg"
      fill="white"
      viewBox="0 0 448 512"
      {...props}
    >
      <path d="M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z" />
    </svg>
  );
};

export default React.memo(CardMessageMobileTable);
